import { useEffect } from 'react';

import { useLocalStorage } from 'react-use';
import { useRouter } from 'next/router';

import { affiliateLocalstorageKey } from 'utils/affiliates';

export default function useAffiliateId() {
    const router = useRouter();

    const [affiliateId, setAffiliateId, clearAffiliateId] = useLocalStorage(affiliateLocalstorageKey);

    useEffect(() => {
        const { affiliateId: newAffiliateId, ...query } = router.query;

        if (newAffiliateId) {
            setAffiliateId(newAffiliateId);
            router.replace({
                pathname: router.pathname,
                query,
            }, undefined, { shallow: true });
        }
    }, [router, setAffiliateId]);

    return [affiliateId, setAffiliateId, clearAffiliateId];
}
